import React, { useContext } from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";
import DeliveryTripList from "../DeliveryTrip";
import ImportRequest from "../ImportRequest";
import { ROLE, SALE_ORDER_STATUS } from "../../../../data/enums";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { isReserveImportAreaVisible } from "../../../ReserveOrder/utils";

interface SaleOrderTabNavigationProps {
    productOrderInfoTab: React.ReactNode;
    productOrder: any; // Use any type to match the sales order structure
    mergeProductOrder: Function;
    fetchProductOrder: () => Promise<void>;
    isReserve?: boolean;
    canImportReserve?: boolean;
}

const SaleOrderTabNavigation = ({
                                    productOrderInfoTab,
                                    productOrder,
                                    mergeProductOrder,
                                    fetchProductOrder,
                                    isReserve = false,
                                    canImportReserve = false,
                                }: SaleOrderTabNavigationProps) => {
    const { user: { role } } = useContext(AuthenticationContext);
    const isSaleRestricted = [ROLE.SALE_STAFF, ROLE.SALE_MANAGER].includes(role);
    const disabledEdit = [
        SALE_ORDER_STATUS.COMPLETED,
        SALE_ORDER_STATUS.CANCELLED,
    ].includes(productOrder.status);

    const products = productOrder?.products || [];
    const materials = productOrder?.materials || [];
    const isMaterialsOnly = products.length === 0 && materials.length > 0;

    const status = productOrder.status === SALE_ORDER_STATUS.IMPORTING_AND_EXPORTING || productOrder.status === SALE_ORDER_STATUS.COMPLETED;

    const showImportTab =
        !isMaterialsOnly
        && (isReserve
            ? isReserveImportAreaVisible(productOrder.status)
            : !isSaleRestricted && status);

    const tabs: TabBarProps[] = [
        {
            label: "Thông tin",
            labelEN: "info",
            content: productOrderInfoTab,
        },
        ...(showImportTab
            ? [
                {
                    label: isReserve ? "Nhập kho" : "Đề nghị nhập kho",
                    labelEN: "import request",
                    content: <ImportRequest productOrder={productOrder} fetchProductOrder={fetchProductOrder}
                                            disabledEdit={disabledEdit}
                                            canImportReserve={canImportReserve} />,
                },
            ]
            : []),
        ...(!isReserve
            ? [
                  {
                      label: "Kế hoạch vận chuyển",
                      labelEN: "delivery trips",
                      content: (
                          <DeliveryTripList
                              deliveryTrips={productOrder.delivery_trips || []}
                              mergeDeliveryTrip={mergeProductOrder}
                              fetchProductOrder={fetchProductOrder}
                              isView={
                                  ![
                                      ROLE.PRODUCTION_STAFF,
                                      ROLE.MANAGER,
                                      ROLE.LOGISTIC_MANAGER,
                                  ].includes(role)
                              }
                              products={productOrder.products || []}
                              productOrder={productOrder}
                          />
                      ),
                  },
              ]
            : []),
    ];

    return <TabBar tabs={tabs} />;
};

export default SaleOrderTabNavigation;
